var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlappedWordmark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 96,
    viewBox: "0 0 520 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Outlapped",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wordmarkSheen",
    x1: 0,
    y1: 0,
    x2: 520,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "skewX(-10)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 72,
    fill: "url(#wordmarkSheen)",
    fontFamily: "Arial Black, Impact, sans-serif",
    fontSize: 62,
    fontWeight: 900,
    letterSpacing: -3
  }, "\n      OUTLAPPED\n    "), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 31,
    width: 118,
    height: 8,
    fill: "#FFFFFF",
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 31,
    width: 94,
    height: 8,
    fill: "#FFFFFF",
    opacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlappedWordmark);
export default __webpack_public_path__ + "static/media/outlapped-wordmark.f85b45049f7fc6f7bd4f2d4fd1d45900.svg";
export { ForwardRef as ReactComponent };